import { ActionIcon, type ActionIconProps, Tooltip } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import { useLogout } from "@/common/hooks/use-logout";

export function SignOutIconButton(props: ActionIconProps) {
	const logout = useLogout();
	return (
		<Tooltip label="Sign Out">
			<ActionIcon
				onClick={() => logout.mutate()}
				variant="subtle"
				size="xl"
				loading={logout.isPending}
				{...props}
			>
				<IconLogout stroke={1.5} />
			</ActionIcon>
		</Tooltip>
	);
}
